import './ExploreLeftSection.css';
import exploreLeftSection from '../../img/explore-left-section.svg';
import { useState, useEffect } from 'react';
import parse from 'html-react-parser';

const ExploreLeftSection = () => {

    if (window.twttr) {
        window.twttr.widgets.load();
    }

    const [adsList, setAdsList] = useState([]);
    const [adsLoading, setAdsLoading] = useState(false);

    const getAdWebAds = async () => {
        const adsResponse = await fetch("https://adweb-api.herokuapp.com/embed-code/twitter/pub1-1621052754260/300/3", {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        })
            .then(res => res.json())
            .then((data) => {
                console.log(data);
                setAdsList(data.data);
                setAdsLoading(true);
            })
    }

    useEffect(() => {
        getAdWebAds();
    }, [])

    return (
        <div className="explore-left-section-wrapper">
            {
                adsLoading ?
                adsList.map(x => {
                    return parse(x.embed_code)
                })
                :
                <div className="loader-wrapper">
                    <div className="loader"></div>
                </div>
            }
        </div>
    )
};

export default ExploreLeftSection;